import React from 'react';
import { cn } from './cn';

/**
 * FreeSlotChip — a compact, tappable chip representing an available booking
 * slot (e.g. "6:00 PM"). Green-outlined when free; muted + disabled when
 * unavailable; filled when selected.
 *
 * Props:
 *  - time:      label text (e.g. "6:00 PM" or "6–7 PM")
 *  - selected:  filled/active style
 *  - disabled:  unavailable style (not clickable)
 *  - onClick:   selection handler
 *  - size:      'sm' | 'md'
 */
const SIZES = {
  sm: 'px-2.5 py-1 text-[11px]',
  md: 'px-3 py-1.5 text-xs',
};

export default function FreeSlotChip({ time, selected = false, disabled = false, onClick, size = 'md', className, children, ...props }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-pressed={selected}
      className={cn(
        'inline-flex items-center justify-center rounded-ga-full border font-semibold transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-ga-focus',
        SIZES[size] || SIZES.md,
        disabled
          ? 'cursor-not-allowed border-ga-border-subtle bg-ga-bg-surface-subtle/40 text-ga-text-subtle line-through'
          : selected
            ? 'border-ga-primary bg-ga-primary text-ga-text-on-primary'
            : 'border-ga-primary/40 bg-transparent text-ga-primary hover:bg-ga-primary-soft',
        className
      )}
      {...props}
    >
      {children || time}
    </button>
  );
}
